import { FormCheckbox } from '@spotify-internal/encore-web';
import PropTypes from 'prop-types';

import withTranslation from 'lib/shared/i18n/withTranslation';
import { contentLegalReportingFieldPropType } from 'utils/custom-proptypes';
import BaseField from 'components/Fields/BaseField/BaseField';

class CheckboxField extends BaseField {
  static propTypes = {
    field: contentLegalReportingFieldPropType,
    value: PropTypes.bool,
  };

  static defaultProps = {
    value: false,
  };

  render() {
    const { field, t, value, label, onFieldChange } = this.props;
    const indicator = field.required ? 'required' : null;

    // TODO: make the error color the checkbox red or perhaps we get this in the next version of tape?
    return (
      <>
        <FormCheckbox
          id={field.name}
          data-testid={field.name}
          required={indicator}
          name={field.name}
          aria-describedby={this.getAriaDescribedBy()}
          aria-required={field.required}
          aria-invalid={this.showError()}
          onChange={onFieldChange}
          checked={value}
        >
          {typeof label === 'string' ? t(label) : label}
        </FormCheckbox>
        {this.getHelpText()}
        {this.getError()}
      </>
    );
  }
}

export default withTranslation()(CheckboxField);
